export function getMerchantId(merchant) {
  if (!merchant) {
    return null;
  }

  const id = merchant.MerchantId ?? merchant.merchantId;
  if (id == null || id === '') {
    return null;
  }

  const numericId = Number(id);
  return Number.isFinite(numericId) && numericId > 0 ? numericId : null;
}

export function normalizeMerchant(merchant) {
  if (!merchant) {
    return merchant;
  }

  const merchantId = getMerchantId(merchant);
  if (merchantId == null) {
    return merchant;
  }

  return {
    ...merchant,
    MerchantId: merchantId,
  };
}
